import { render, staticRenderFns } from "./select-audio-win.vue?vue&type=template&id=7037d4f7&"
import script from "./select-audio-win.vue?vue&type=script&lang=js&"
export * from "./select-audio-win.vue?vue&type=script&lang=js&"
import style0 from "./select-audio-win.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/willin/Documents/shiwangme/shiwangme_new_cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7037d4f7', component.options)
    } else {
      api.reload('7037d4f7', component.options)
    }
    module.hot.accept("./select-audio-win.vue?vue&type=template&id=7037d4f7&", function () {
      api.rerender('7037d4f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "client/components/select-audio-win.vue"
export default component.exports